const getBlobObj = (responseData) => {
  if (responseData instanceof Blob) {
    return responseData;
  } else {
    return new Blob([responseData], { type: 'application/pdf' });
  }
};

export default getBlobObj;
